module.exports = __webpack_public_path__ + "static/media/dodgem(2).75a94b6e.PNG";